import { NgModule } from '@angular/core';

import { DynamicFormModule } from '@mt-ng2/dynamic-form';
import { EntityComponentsNotesModule } from '@mt-ng2/entity-components-notes';
import { EntityComponentsPhonesModule } from '@mt-ng2/entity-components-phones';
import { EntityComponentsAddressesModule } from '@mt-ng2/entity-components-addresses';
import { EntityComponentsDocumentsModule } from '@mt-ng2/entity-components-documents';
import { SharedEntitiesModule } from '@mt-ng2/shared-entities-module';
import { AccessRequestsModule } from '@mt-ng2/access-requests-module';
import { CommonModule } from '@angular/common';
import { MtSearchBarControlModule } from '@mt-ng2/searchbar-control';
import { MtSearchFilterSelectModule } from '@mt-ng2/search-filter-select-control';
import { EntityListModule } from '@mt-ng2/entity-list-module';
import { VisibilityModule } from '@mt-ng2/visibility-module';
import { MtDateModule } from '@mt-ng2/date-module';
import { MtDocumentControlModule } from '@mt-ng2/document-control';
import { ModalModule } from '@mt-ng2/modal-module';

/**
 * Feature Module contains all imports and exports that are specific to Features and common between both portals.
 * This makes importing the standard grouping of mt-ng2 and angular modules easy and also helps with
 * bundling by having a consistent feature module grouping.
 *
 * This should only be imported to the portal specific FeatureModule.
 *
 * Tip: If the import/export should be included in all modules, including the root AppModule at
 * startup, than consider putting it into "SharedModule" instead.
 */
@NgModule({
    exports: [
        DynamicFormModule,
        EntityComponentsNotesModule,
        EntityComponentsPhonesModule,
        EntityComponentsAddressesModule,
        EntityComponentsDocumentsModule,
        SharedEntitiesModule,
        AccessRequestsModule,
        MtSearchBarControlModule,
        MtSearchFilterSelectModule,
        EntityListModule,
        VisibilityModule,
        MtDateModule,
        MtDocumentControlModule,
        ModalModule,
    ],
    imports: [
        CommonModule,
        DynamicFormModule,
        EntityComponentsNotesModule,
        EntityComponentsPhonesModule,
        EntityComponentsAddressesModule,
        EntityComponentsDocumentsModule,
        SharedEntitiesModule,
        AccessRequestsModule,
        MtSearchBarControlModule,
        MtSearchFilterSelectModule,
        EntityListModule,
        VisibilityModule,
        MtDateModule,
        MtDocumentControlModule,
        ModalModule,
    ],
})
export class FeatureModule {}
